import React, { Component } from 'react';

export default class AdminNotesModal extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="admin-notes-modal">
                <div className="admin-notes-modal-body">
                    <div className="admin-modal-content">
                        <h4>Admin Notes</h4>
                        <hr />
                        <p>{this.props.job.admin_notes}</p>
                        <p>Two person job: {this.props.job.two_person_team ? 'Yes' : 'No'}</p>
                    </div>
                    <hr />
                    <div className="admin-notes-modal-footer">
                        <button className="btn btn-cw-primary" onClick={(e) => this.props.onHide(e, false, null)}>
                            Close
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
